function scrollToTop() {
  // Scroll to the top of the page with smooth animation
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

export default scrollToTop;